export default function () {
  return [
    {
      type: 'Input',
      title: '所属宣传团队',
      readOnly: true,
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '加入时间',
      [$field]: 'joinPartyDate',
      rules: ['']
    },
    {
      type: 'Input',
      title: '擅长领域',
      [$field]: 'expandFielda',
      rules: []
    }
  ]
}